export default "__VITE_ASSET__DZYWQb7m__"